import { LuSearch, LuCheck } from "@/Components/Icons/Icons.jsx";
export default {
  row1: [
    {
      column: "column1",
      columnWidth: "47%",
      rows: {
        row1: [
          {
            name: "importContainerNo",
            label: "Container No",
            component: "text-field",
            required: true,
          },
        ],
        row2: [
          {
            name: "importContainerLoadType",
            label: "Loader Type",
            component: "dropdown",
            endIconName: "LuChevronDown",
            options: [
              { label: "FCL", value: "FCL" },
              { label: "LCL", value: "LCL" },
            ],

          },

        ],
        row3: [
          {
            name: "importContainerTruckNumber",
            label: "Truck Number",
            component: "text-field",
          },
        ],
        row4: [
          {
            name: "importContainerPkgsStuffed",
            label: "Pkgs Stuffle",
            component: "text-field",
            dataType: "int",
          },
        ],
        row5: [
          {
            name: "importContainerSealNo",
            label: "Seal No",
            component: "text-field",
          },
        ],
      },
    },
    {
      column: "column2",
      columnWidth: "50%",
      rows: {
        row1: [
          {
            name: "importContainerContType",
            label: "Container Type",
            component: "dropdown",
            endIconName: "LuChevronDown",
            options: [
              { label: "20 Bulk", value: "20 Bulk" },
              { label: "20 Standard Dry", value: "20 Standard Dry" },
              { label: "20 Flat Rack", value: "20 Flat Rack" },
              { label: "20 Collapsible Flat Rack", value: "20 Collapsible Flat Rack" },
              { label: "20 Reefer", value: "20 Reefer" },
              { label: "20 Tank", value: "20 Tank" },
              { label: "20 Open Top", value: "20 Open Top" },
              { label: "20 Hard Top", value: "20 Hard Top" },
              { label: "20 Platform", value: "20 Platform" },
              { label: "40 Standard Dry", value: "40 Standard Dry" },
              { label: "40 Flat Rack", value: "40 Flat Rack" },
              { label: "40 Collapsible Flat Rack", value: "40 Collapsible Flat Rack" },
              { label: "40 Reefer", value: "40 Reefer" },
              { label: "40 Tank", value: "40 Tank" },
              { label: "40 Open Top", value: "40 Open Top" },
              { label: "40 Hard Top", value: "40 Hard Top" },
              { label: "40 High Cube", value: "40 High Cube" },
              { label: "40 Reefer High Cube", value: "40 Reefer High Cube" },
              { label: "40 Platform", value: "40 Platform" }
            ],

          },
        ],
        row2: [
          {
            name: "importContainerEmptyCntrLocation",
            label: "Empty Container Location",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getCFS",
            disabled: true,
          },
        ],
        row3: [
          {
            name: "importContainerGrossweight",
            label: "Gross Weight",
            component: "text-field",
            dataType: "int",
          },
          {
            name: "importContainerGrossweightUnit",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
            icon: LuSearch
          },
        ],
        row4: [
          {
            name: "importContainerGrWtTrWt",
            label: "Gr-Wt-Tr-Wt",
            component: "text-field",
            dataType: "int",
          },
          {
            name: "importContainerGrWtTrWtUnit",
            component: "text-field",
            type: "autocomplete",
            endpoint: "getQuantity",
            icon: LuSearch
          },
        ],
      },
    },
  ]
};
